import { Box as ChakraBox, BoxProps } from '@chakra-ui/react'
import { withShade } from './utils'

export const Box = withShade<BoxProps>(ChakraBox)
